
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { User, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useBuyer } from "@/contexts/BuyerContext";
import { useAuth } from "@/contexts/AuthContext";

const ProfileTypeSelector = () => {
  const navigate = useNavigate();
  const { buyerProfile } = useBuyer();
  const { profile } = useAuth();

  const handleBuyerProfile = () => {
    navigate("/buyer/profile");
  };

  const handleSellerProfile = () => {
    navigate("/seller/profile");
  };

  return (
    <div className="space-y-6 pb-8 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Choose Profile Type</h1>
        <p className="text-muted-foreground">
          You have both buyer and seller accounts. Please select which profile you'd like to manage.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl">
        <Card className="cursor-pointer hover:shadow-lg transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <User className="h-5 w-5 text-godyspo-blue" />
              Buyer Profile
            </CardTitle>
            <CardDescription>
              Manage your investment preferences and saved properties
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">
                <strong>Name:</strong> {buyerProfile?.full_name || "Not set"}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Company:</strong> {buyerProfile?.company_name || "Not set"}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Phone:</strong> {buyerProfile?.phone_number || "Not set"}
              </p>
              <Button 
                onClick={handleBuyerProfile} 
                className="w-full bg-godyspo-blue hover:bg-godyspo-blue/90"
              >
                Manage Buyer Profile
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:shadow-lg transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Building2 className="h-5 w-5 text-godyspo-gold" />
              Seller Profile
            </CardTitle>
            <CardDescription>
              Manage your business information and property listings
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">
                <strong>Name:</strong> {profile?.full_name || "Not set"}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Business:</strong> {profile?.business_name || "Not set"}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Phone:</strong> {profile?.phone_number || "Not set"}
              </p>
              <Button 
                onClick={handleSellerProfile} 
                className="w-full bg-godyspo-gold hover:bg-godyspo-gold/90 text-black"
              >
                Manage Seller Profile
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="bg-muted/50 p-4 rounded-lg max-w-4xl">
        <p className="text-sm text-muted-foreground">
          <strong>Note:</strong> You have both buyer and seller profiles. You can switch between them 
          at any time by visiting the respective profile pages or using the navigation menu.
        </p>
      </div>
    </div>
  );
};

export default ProfileTypeSelector;
